import standardModes from './standardModes';
import digitalModes from './digitalModes';
import printModes from './printModes';
import hfaModes from './hfaModes';
import demoModes from './demoModes';

const modeConfig = {
  tv: standardModes.tv,
  spanish_tv: standardModes.spanish_tv,
  cable: standardModes.cable,
  digital: digitalModes.digital,
  mobile: digitalModes.mobile,
  fb: digitalModes.fb,
  mail: standardModes.mail,
  phone: standardModes.phone,
  radio: standardModes.radio,
  hfa_tv: hfaModes.hfa_tv,
  hfa_digital: hfaModes.hfa_digital,
  hfa_mail: hfaModes.hfa_mail,
  hfa_field: hfaModes.hfa_field,
  digital_dsp_display: demoModes.digital_dsp_display,
  digital_dsp_video: demoModes.digital_dsp_video,
  digital_inapp: demoModes.digital_inapp,
  snapchat: demoModes.snapchat,
  youtube: demoModes.youtube,
  print: printModes.print,
  natl_print: printModes.natl_print,
};

export default modeConfig;
